import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaArrowLeftLong } from 'react-icons/fa6'
import { Link } from 'react-router-dom';

const LocationButton = ({ link }: { link: string }) => {
    const { t } = useTranslation();
    return (
        <div className='h-32  flex-center'>
            <div className=' h-full overflow-hidden rounded-xl'>
                <img src="/asset/images (1) 1.png" alt="map" className='w-full h-full object-cover ' />
            </div>
            <Link to={link} className=' absolute flex-center gap-1 bg-secondry rounded-lg text-white px-2 py-1'>
                {t("map-view")} <FaArrowLeftLong />
            </Link>
        </div>
    )
}

export default LocationButton